import debug from 'debug';

const log = debug('ApiManagement');

class ApiManagement {
	constructor() {
		this.settings = this.settings();
	}

	get(url) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Ocp-Apim-Subscription-Key': this.settings.key
				},
				credentials: 'include'
			}).then(response => {
				log('Get()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('Get() - ERROR', error);
				reject(error);
			});
		});
	}

	async get2(url, signal) {
		const options = {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Ocp-Apim-Subscription-Key': this.settings.key
			},
			credentials: 'include'
		}

		if (signal) {
			options.signal = signal;
		}

		const response = await fetch(url, options);
		const data = await response.json();

		return data;
	}

	post(url, body) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Ocp-Apim-Subscription-Key': this.settings.key
				},
				credentials: 'include',
				body
			}).then(response => {
				log('Get()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('Get() - ERROR', error);
				reject(error);
			});
		});
	}

	settings() {
		let settings;

		try {
			settings = JSON.parse(document.body.getAttribute('data-apim'));
			if (!settings || !settings.key || !settings.url) {
				log('Profile API settings is not set in BODY');
			}
		}
		catch(error) {
			log(error);
		}

		return settings;
	}
}

export default ApiManagement;
